<template>
	<div class="ss-comment-box">
		<div class="publish-title">
			发布评论
			<span>文明上网理性发言，请遵守新闻评论服务协议</span>
			<div class="fr">
				<span>{{pageTotal_}}</span>条评论
			</div>
		</div>
		<div class="publish-input-box clearfix">
			<img src="~@/assets/img/culturalActivity/avatar.png" />
			<div class="publish-input-content">
				<textarea placeholder="文明社会，从理性发帖开始。" v-model="commentText" class="publish-input"></textarea>
				<div class="btn-primary" @click="comment">评论</div>
			</div>
		</div>
		<div class="ss-comment-list-box" v-show="pageTotal > 0">
			<div class="ss-comment-title">
				全部评论
				<!-- <div class="fr">
					<span class="active">最新</span> / <span>最热</span>
				</div> -->
			</div>
			<ul class="ss-comment-list">
				<li class="line-1" v-for="(item, index) in curData_" :key="item.id">
					<div class="ss-comment-top">
						<img class="ss-comment-avatar poster-image-sm" :src="item.user && item.user.userExt | imgUrl('userImgUrl')" />
						<div class="ss-comment-content">
							<div class="ss-comment-user">
								{{item.user && item.user.username || '游客'}}
								<span>{{item.releaseTimestamp | time}}</span>
							</div>
							<div class="ss-comment-text">{{item.commentText}}</div>
							
							<ul class="ss-comment-list" v-if="item.children && item.children.length">
								<li class="line-1" v-for="(child, idx) in item.children" :key="child.id">
									<div class="ss-comment-top">
										<img class="ss-comment-avatar poster-image-sm" :src="child.user && child.user.userExt | imgUrl('userImgUrl')" />
										<div class="ss-comment-content">
											<div class="ss-comment-user">
												{{child.user && child.user.username}}
												<span>{{child.releaseTimestamp | time}}</span>
											</div>
											<div class="ss-comment-text">{{child.commentText}}</div>
										</div>
									</div>
									<div class="ss-comment-bottom">
										<div class="ss-comment-bottom__item" @click="commentUp(child, index, idx)">
											<img src="~@/assets/img/culturalActivity/zan.png" v-if="!child.isLike" />
											<img src="~@/assets/img/culturalInfo/dianzan_sel.png" v-else />
											<span>{{child.upCount | unit}}</span>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="ss-comment-bottom">
						<div class="ss-comment-bottom__item" @click="childrenComment(item, index)">
							<img src="~@/assets/img/culturalActivity/lt.png" />
							<span>{{item.childrenNum | unit}}</span>
						</div>
						<div class="ss-comment-bottom__item" @click="commentUp(item, index)">
							<img src="~@/assets/img/culturalActivity/zan.png" v-if="!item.isLike" />
							<img src="~@/assets/img/culturalInfo/dianzan_sel.png" v-else />
							<span>{{item.upCount | unit}}</span>
						</div>
					</div>
				</li>
			</ul>
			<div class="ss-comment-load-more">
				<button class="btn-default btn-sm btn-noradius" v-if="finish_ && !busy_">加载更多</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				commentText: '',
				replayObj: {},
				focus: false,
				showEdit: -1,
				messageText: '',
				userInfo: {},
				routeName: 'comment'
			}
		},
		props: {
			commentTxt: {
				type: String,
				default: '发表'
			},
			placeholder: {
				type: String,
				default: '输入评论内容...'
			},
			mode: {
				type: String,
				default: 'normal'
			},
			showComment: {
				type: [ String, Boolean ],
				default: true
			}
		},
		watch: {
			mode: {
				handler(val) {
					if(val === 'chat'){
						this.getUserInfo();
					}
				},
				deep: true,
				immediate: true
			}
		},
		computed: {
			showComment_() {
				return String(this.showComment) === 'false' ? false : true;
			}
		},
		methods: {
			...mapActions('user', ['GetUserInfoHandle']),
			async childrenComment(item, index) {
				if(item.childrenNum <= 0) return ;
				let res = await this.$http('childrenComment', {
					parentId: item.id
				});
				if(res.code === 1){
					this.$set(this.pageData[0][index], 'children', res.data);
					console.log(this.pageData);
				}
			},
			async getUserInfo(){
				let userInfo = await this.GetUserInfoHandle();
				this.userInfo = userInfo;
			},
			showEditFun(index) {
				if(this.showEdit === index) return this.showEdit = -1;
				this.messageText = '';
				this.showEdit = index;
			},
			async sendMessage(id) {
				if(!this.messageText) return this.$toast('发送内容不能为空');
				let res = await this.$http('sendMessage', {
					memeberId: [id],
					content: this.messageText
				})
				if(res.code === 1) this.showEditFun(this.showEdit)
			},
			async commentUp(obj, index, cIndex){
				let { isLike, id } = obj;
				let pageData = this.$deepClone(this.pageData);
				let upCount = isLike ? obj.upCount - 1 : obj.upCount + 1;
				if(cIndex !== undefined){
					pageData[0][index].children[cIndex].upCount = upCount < 0 ? 0 : upCount;
					pageData[0][index].children[cIndex].isLike = !isLike;
				}else{
					pageData[0][index].upCount = upCount < 0 ? 0 : upCount;
					pageData[0][index].isLike = !isLike;
				}
				let res = await this.$http( isLike ? 'commentCancelUp' : 'commentUp', {
					commentId: id
				});
				res.code === 1 && (this.pageData = pageData);
			},
			inputBlur() {
				this.focus = false;
			},
			goDetial(id){
				if(this.mode === 'message'){
					this.$Router.push({
						name: 'privateMessageRecord',
						params: {
							userId: id
						}
					})
				}else{
					this.$Router.push({
						name: 'commentDetail',
						params: {
							comId: id,
							contentId: this.contentId
						}
					})
				}
			},
			reply(index) {
				if(index !== undefined){
					let { id, user: { username } } = this.listData[index];
					this.replayObj = {
						id: id,
						username: username,
						index: index
					}
					this.focus = true;
					this.commentText = '';
				}else{
					this.replayObj = {}
				}
			},
			async comment() {
				if(!this.commentText){
					return this.$toast('评论内容不能为空');
				}
				let params = {
					contentId: this.contentId,
					commentText: this.commentText,
					parentId: this.comId || this.replayObj.id || ''
				}
				let res = await this.$http('comment', params);
				console.log(res);
				if(res.code === 1){
					this.commentText = '';
					this.init(true);
				}
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.ss-comment-box{
		width: 740px;
		margin: 0 auto;
		.publish-input-box{
			position: relative;
			img{
				@include abs(0, null, null, 0);
				width: 30px;
				height: 30px;
			}
			.publish-input-content{
				width:700px;
				height:100px;
				float: right;
				padding-right: 100px;
				background:rgba(255,255,255,1);
				border:1px solid rgba(211,211,211,1);
			}
			.publish-input{
				height: 98px;
				width: 100%;
				padding: 10px 17px;
				resize: none;
			}
			.btn-primary{
				width: 100px;
				height: 100px;
				line-height: 98px;
				@include abs(0, 0, 0);
				font-size:18px;
				font-weight:400;
				border-radius: 0;
			}
		}
		.activity-detail__tab{
			margin-top: 45px;
		}
		.publish-title{
			font-size:20px;
			font-weight:400;
			color:rgba(23,23,23,1);
			line-height:56px;
			span{
				font-size:12px;
				font-weight:400;
				color:rgba(204,204,204,1);
				line-height:56px;
			}
			.fr{
				font-size:14px;
				font-weight:400;
				color:rgba(136,136,136,1);
				line-height:56px;
				span{
					font-size:22px;
					font-family:Georgia;
					font-weight:400;
					color:rgba(2,96,254,1);
					line-height:56px;
				}
			}
		}
		.ss-comment-list-box{
			margin-top: 20px;
			border-top: 1px solid #efefef;
			.ss-comment-load-more{
				border-top: 1px solid #efefef;
				padding: 30px;
				.btn-default{
					width:160px;
				}
			}
			.ss-comment-title{
				border-top:1px solid rgba(222,222,222,1);
				font-size:20px;
				font-weight:400;
				color:rgba(23,23,23,1);
				line-height:56px;
				.fr{
					font-size:14px;
					font-weight:400;
					color: #a7a7a7;
					line-height:56px;
					.active{
						color: rgba(23,23,23,1);
					}
				}
			}
			.ss-comment-list{
				.ss-comment-list{
					background:rgba(248,248,248,1);
					padding: 20px 20px 0;
					margin-top: 20px;
				}
				li{
					& + li{
						margin-top: 20px;
					}
					.ss-comment-bottom{
						padding: 20px 0;
						.ss-comment-bottom__item{
							display: inline-block;
							cursor: pointer;
						}
						img{
							width: 16px;
							display: inline-block;
							vertical-align: middle;
						}
						span{
							font-size:16px;
							font-weight:400;
							color: #666666;
							line-height:18px;
							margin-right: 30px;
							margin-left: 8px;
							display: inline-block;
							vertical-align: middle;
						}
					}
					.ss-comment-top{
						position: relative;
						padding-left: 42px;
						.ss-comment-avatar{
							@include abs(0, null, null, 0);
							width: 30px;
							height: 30px;
							border-radius: 100%;
						}
						.ss-comment-content{
							.ss-comment-user{
								font-size:14px;
								font-weight:400;
								color:rgba(23,23,23,1);
								line-height:38px;
								span{
									color: #999999;
								}
							}
							.ss-comment-text{
								margin-top: 10px;
								font-size:14px;
								font-weight:400;
								color:rgba(153,153,153,1);
								line-height:24px;
							}
						}
					}
					&:last-child::after{
						display: none;
					}
				}
			}
		}
	}
</style>
